import { prettifyString } from "@/lib/helpers.ts";
import { Pill } from "@mantine/core";

type Props = {
  value: string | null;
  onRemove: () => void;
};

export function AccessoriesPill({ value, onRemove }: Props) {
  if (!value) {
    return <></>;
  }

  return (
    <Pill
      color="blue"
      variant="filled"
      radius="md"
      size="sm"
      withRemoveButton
      onRemove={() => onRemove()}
    >
      {prettifyString(value.replace("random", ""))}
    </Pill>
  );
}
